import React, { Fragment } from "react";

import "./Upload.css";

class Upload extends React.Component {
  constructor(props) {
    super(props);
    //this.toggleClass = this.toggleClass.bind(this);
    this.state = { imageActive: false };
  }

  render() {
    return (
      <Fragment>
        <div>
          <span
            className="c-RD-profile__input-name "
            style={{ marginRight: "0 !important" }}
          >
            فایل تصویر
          </span>
          <div
            className="mn-grid__row c-RD-profile__logo--placeholder uk-margin-remove-top "
            style={{ marginRight: "0 !important", position: "relative" }}
          >
            <img
              src={this.props.imageUrl}
              className={[
                "c-RD-profile__add-doc-img uk-height-1-1 uk-width-1-1 ",
                `${!this.props.imageUrl && "uk-hidden"}`,
              ].join(" ")}
            />
            <label
              className={[
                "c-RD-profile__add-doc-upload",
                `${this.props.imageUrl && "uk-hidden"}`,
              ].join(" ")}
            >
              <input
                className="js-profile-docUpload-upload"
                type="file"
                id={this.props.id}
                onChange={(e) =>
                  this.props.onChange(
                    this.props.id,
                    e.target.value,
                    e.target.files
                  )
                }
                onBlur={this.props.onBlur}
                accept="image/jpg,image/png,image/jpeg"
              />
              {/* <input name="docUpload[document_imageid]" type="hidden" /> */}
            </label>
            <div className="c-profile-doc-upload-logo-has-error uk-hidden">
              <div></div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default Upload;

  